import React from "react";
import { TimePicker } from "antd";
import "./TimeField.scss";

const TimeField = ({
  title,
  value,               // dayjs | null
  onChange,            // (dayjs|null, timeString) => void
  name,
  placeholder = "HH : MM : SS",
  required = false,
  disabled = false,
  errorText = "",
  helperText = "",
  size = "large",
  format = "HH:mm:ss",
}) => {
  const hasError = Boolean(errorText);

  return (
    <div className={`forminput ${hasError ? "has-error" : ""}`}>
      {title && (
        <span className="input-label">
          {title}
          {required && <span className="required-asterisk"> *</span>}
        </span>
      )}

      <div className="input-container">
        <TimePicker
          className="time-input"
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          size={size}
          format={format}
          allowClear
        />
      </div>

      {hasError ? (
        <span className="input-error-text">{errorText}</span>
      ) : (
        helperText && <span className="input-helper-text">{helperText}</span>
      )}
    </div>
  );
};

export default TimeField;
